import { motion } from 'framer-motion';
import { resumeData } from '../data/resumeData';

export default function Workshops() {
  const { trainings } = resumeData;

  return (
    <section id="workshops" className="py-24 px-6 bg-black relative overflow-hidden">
      <div className="container mx-auto max-w-6xl relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="mb-16 text-center"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="inline-block mb-4"
          >
            <span className="px-4 py-2 bg-green-500/10 border border-green-500/20 rounded-full text-green-400 text-sm font-mono tracking-wider">
              TRAININGS
            </span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="text-3xl md:text-4xl font-display font-bold"
          >
            <span className="bg-gradient-to-r from-green-400 via-primary to-green-400 bg-clip-text text-transparent">
              Trainings & Workshops
            </span>
          </motion.h2>

          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "100%" }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="h-px bg-gradient-to-r from-transparent via-green-500/50 to-transparent max-w-md mx-auto mt-4"
          />
        </motion.div>

        {/* Trainings Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {trainings.map((training, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
              className="relative bg-[rgb(39,39,42)] rounded-2xl p-6 border border-gray-800 hover:border-green-500/30 transition-all cursor-pointer overflow-hidden"
            >
              {/* Hover gradient overlay */}
              <motion.div
                className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500 rounded-2xl pointer-events-none"
              />

              <h3 className="text-xl font-bold mb-2 text-white z-10 relative">{training.title}</h3>
              <p className="text-green-400 mb-4 z-10 relative">{training.organization}</p>
              
              <div className="flex items-center justify-between mb-6 z-10 relative">
                <span className="text-sm text-gray-300">{training.year}</span>
                {training.participants && (
                  <span className="text-sm text-gray-300">
                    {training.participants}+ participants
                  </span>
                )}
              </div>

              {training.topics && (
                <div className="flex flex-wrap gap-2 z-10 relative">
                  {training.topics.map((topic, i) => (
                    <motion.span
                      key={i}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: false, amount: 0.5 }}
                      transition={{ duration: 0.4, delay: i * 0.1 }}
                      className="px-3 py-1 bg-black/50 text-sm rounded-full text-gray-300 hover:bg-black/80 transition-colors"
                    >
                      {topic}
                    </motion.span>
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
